// ---------------------------------------------------------------------------
// `useFrame` do r3f com medição opcional (P1, só com "?dbg=1"): soma o tempo dos handlers de cada quadro.
// Sem a flag, exporta o PRÓPRIO useFrame do r3f (mesma função: zero custo e zero diferença de comportamento).
// Com a flag, o handler é chamado pelo mesmo caminho, com os mesmos argumentos, e só se lê o relógio antes e depois.
// ---------------------------------------------------------------------------
import { useFrame as r3fUseFrame } from '@react-three/fiber';
import { DBG_ENABLED } from './dbgFlag';
import { p1 } from './p1Probe';

export const useFrame: typeof r3fUseFrame = DBG_ENABLED
  ? (((cb: any, renderPriority?: number) =>
      r3fUseFrame((state: any, delta: number, frame: any) => {
        const t = performance.now();
        cb(state, delta, frame);
        p1!.addUF(performance.now() - t);
      }, renderPriority)) as typeof r3fUseFrame)
  : r3fUseFrame;
